import React, { useState, useEffect } from 'react';
import '../../styles/AdminModal.css';
import { updateBlogCategory } from '../../services/AdminBlogService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose } from '@fortawesome/free-solid-svg-icons';
import BlogCategoryForm from '../../forms/blog/BlogCategoryForm';

const BlogCategoryEditModal = ({ isOpen, onClose, onSuccess, category }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    is_active: true,
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (category && isOpen) {
      setFormData({
        name: category.name || '',
        description: category.description || '',
        is_active: category.is_active !== undefined ? category.is_active : true,
      });
      setErrors({});
    }
  }, [category, isOpen]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleSave = async () => {
    if (!formData.name.trim()) {
      setErrors({ name: 'Name is required' });
      return;
    }

    setLoading(true);
    setErrors({});

    try {
      await updateBlogCategory(category.id, formData);
      onSuccess();
    } catch (error) {
      console.error('Error updating blog category:', error);
      setErrors({ general: 'Failed to update blog category. Please try again.' });
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen || !category) return null;

  return (
    <div className="admin__modal">
      <div className="admin__modal-content">
        <div className="admin__modal-intro">
          <h2>Edit Blog Category</h2>
          <button className="admin__modal-close" onClick={onClose}>
            <FontAwesomeIcon icon={faClose} />
          </button>
        </div>

        {errors.general && (
          <div className="error-message">{errors.general}</div>
        )}

        <div className="admin__modal-body">
          <BlogCategoryForm
            formData={formData}
            errors={errors}
            handleChange={handleChange}
          />
        </div>

        <div className="admin__modal-buttons">
          <button className="button secondary" onClick={onClose} disabled={loading}>
            Cancel
          </button>
          <button className="button" onClick={handleSave} disabled={loading}>
            {loading ? 'Saving...' : 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BlogCategoryEditModal; 